<template>
    <span>{{ display }}</span>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from "vue"
import { toCurrency } from "@/libs/helpers.ts"
import { defineProps } from "vue"

const props = defineProps({
    value: {
        type: [Number, String],
        required: true,
    },
    animate: {
        type: Boolean,
        default: true,
    },
})

const displayValue = ref(0)
let interval = null

const display = computed(() => {
    return toCurrency(displayValue.value.toFixed(2))
})

const animateValue = (newVal) => {
    clearInterval(interval)
    if (newVal === displayValue.value) {
        return
    }

    interval = setInterval(() => {
        let change = (newVal - displayValue.value) / 10
        displayValue.value += change

        if (Math.abs(newVal - displayValue.value) < 0.01) {
            displayValue.value = newVal
            clearInterval(interval)
        }
    }, 7)
}

const updateValue = (newVal) => {
    if (props.animate) {
        animateValue(Number(newVal))
    } else {
        displayValue.value = Number(newVal)
    }
}

watch(
    () => props.value,
    (newVal) => {
        updateValue(newVal)
    },
)

onMounted(() => {
    displayValue.value = Number(props.value)
})

onBeforeUnmount(() => {
    clearInterval(interval)
})
</script>
